import { Link } from 'react-router-dom';
import { Calendar, MessageSquare } from 'lucide-react';
import { ROUTES } from './Navigation/routes';
import { BOOK_CALL_URL } from '../constants/links';

/**
 * Reusable mid-page conversion banner. Offers a low-friction "book a call"
 * path alongside the fuller work-request form on the homepage.
 */
const CTABanner = ({ title, description }) => {
  return (
    <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-8 sm:p-12 shadow-xl">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">{title}</h3>
          {description && <p className="text-purple-100 text-lg">{description}</p>}
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <a
            href={BOOK_CALL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-purple-700 font-semibold rounded-lg hover:bg-purple-50 transition-colors whitespace-nowrap"
          >
            <Calendar className="w-5 h-5" /> Book a Call
          </a>
          <Link
            to={ROUTES.CONTACT}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-purple-900/30 border-2 border-white/40 text-white font-semibold rounded-lg hover:bg-purple-900/50 transition-colors whitespace-nowrap no-underline"
          >
            <MessageSquare className="w-5 h-5" /> Send a Request
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CTABanner;
